import { Verification } from "../../../services/verifyService/model";
import { CompositeSpecification } from "../../../utils/Specification";

export class RequiresReferralNumber extends CompositeSpecification<Verification> {
    IsSatisfiedBy(candidate: Verification): boolean {
        // Returns true if referral number is present and not empty
        return !!(candidate.authorization.referralNumber && candidate.authorization.referralNumber.trim() !== '');
    }
}